import { useState } from "react";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { BotaoBusca } from "@/components/busca/BotaoBusca";
import { Avatar } from "@/components/Avatar";
import { useAuth } from "@/lib/auth";
import { OrganizationSwitcher } from "../OrganizationSwitcher";
import { GavetaDoPerfil } from "./GavetaDoPerfil";

type Props = {
  tourDisponivel?: boolean;
  mostrarSeloDoTour?: boolean;
  onIniciarTour?: () => void;
};

/**
 * Topo do celular, no desenho do LinkedIn: foto (abre o perfil), o seletor de organização no lugar
 * da busca, lupa e sino. Sem título da página — a aba ativa embaixo diz onde a pessoa está.
 */
export function BarraSuperiorCelular({ tourDisponivel, mostrarSeloDoTour, onIniciarTour }: Props) {
  const { user } = useAuth();
  const [perfilAberto, setPerfilAberto] = useState(false);

  return (
    <div className="flex w-full items-center gap-2">
      <button
        type="button"
        onClick={() => setPerfilAberto(true)}
        aria-label="Abrir perfil"
        className="relative flex h-11 w-11 shrink-0 items-center justify-center rounded-full"
      >
        <Avatar src={user?.image} name={user?.name} size="md" />
        {mostrarSeloDoTour && tourDisponivel && (
          <span className="absolute right-0.5 top-0.5 h-2.5 w-2.5 rounded-full bg-brand-600 ring-2 ring-white dark:ring-card" />
        )}
      </button>
      <div className="min-w-0 flex-1">
        <OrganizationSwitcher variante="celular" />
      </div>
      <BotaoBusca />
      <NotificationBell />
      <GavetaDoPerfil
        aberta={perfilAberto}
        onFechar={() => setPerfilAberto(false)}
        tourDisponivel={tourDisponivel}
        mostrarSeloDoTour={mostrarSeloDoTour}
        onIniciarTour={onIniciarTour}
      />
    </div>
  );
}
